export const emailRegex = /^[a-zA-Z0-9_.]+@[a-zA-Z]+\.[a-zA-Z.]+$/;